import SelectionStatus from 'portfolio/components/SelectionStatus';
import React from 'react';

import VenueAnalysisHelp from 'widgets/venueAnalysis/help/VenueAnalysisHelp';
import { VenueAnalysisNavigation } from 'widgets/venueAnalysis/navigation/VenueAnalysisNavigation';
import { VenueAnalysisData } from 'widgets/venueAnalysis/venueAnalysisAggregatedData';
import VenueAnalysisSettings from './VenueAnalysisSettings';
import WidgetToolbar from 'widgets/WidgetToolbar/WidgetToolbar';
import { useWidgetPortfolioSelectionStatus } from 'widgets/hooks';
import { VenueAnalysisSelection } from 'widgets/venueAnalysis/store/component/VenueAnalysisSelection';
import WidgetToolbarShowHidePanel from 'widgets/WidgetToolbarShowHidePanel/WidgetToolbarShowHidePanel';
import { venueAnalysisStreamedDataSelectors } from 'widgets/venueAnalysis/store/stream/streamSlice';

interface VenueAnalysisToolbarProps {
    data?: VenueAnalysisData;
    selection?: VenueAnalysisSelection;
    onChangeSelection: (selection?: VenueAnalysisSelection) => void;
}

export default function VenueAnalysisToolbar(props: VenueAnalysisToolbarProps) {
    const { data, selection, onChangeSelection } = props;

    const { hasValidSelection, portfolioSelectionRequirements } =
        useWidgetPortfolioSelectionStatus();

    const { useWidgetMessages } = venueAnalysisStreamedDataSelectors;
    const messages = useWidgetMessages();

    return (
        <WidgetToolbarShowHidePanel mustShow={!hasValidSelection}>
            <div className="VenueAnalysisToolbar panel-header">
                <div className="toolbar">
                    {hasValidSelection && (
                        <VenueAnalysisNavigation
                            data={data}
                            selection={selection}
                            onChangeSelection={onChangeSelection}
                        />
                    )}
                    <SelectionStatus
                        widgetName="Venue Analysis Widget"
                        selectionRequirements={portfolioSelectionRequirements}
                    />
                </div>
                <WidgetToolbar
                    preceedingItems={<VenueAnalysisHelp />}
                    settingsHeader="Venue Analysis Settings"
                    settingsBody={<VenueAnalysisSettings />}
                    messages={hasValidSelection ? messages : []}
                />
            </div>
        </WidgetToolbarShowHidePanel>
    );
}
